"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubWindow = void 0;
var MockDataStore_1 = require("../store/MockDataStore");
var isSubWindow = function () {
    return MockDataStore_1.mockStore.getMockData('isSubWindow');
};
exports.isSubWindow = isSubWindow;
